import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Spin,
  notification,
  Select,
} from "antd";

import React, { useEffect, useCallback, useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import AllergensApi from "../../common/Apis/AllergensApi";
import DepartmentDropdown from "../../common/DropDowns/Department";

const AddAllergens = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      allergensName: data.allergensName,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    AllergensApi.CreateAllergensApi(formData)
      .then((response) => {
        console.log(response);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Created</span>,
          description: "Created Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });

        return navigate("/masters/allergens");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={0}>
                <Col lg={12} md={12}>
                  <Form.Item
                    name="allergensName"
                    label="Allergens Name*"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Allergens Name",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Allergens Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>


              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",
                 
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #d9d9d9",
                    color: "#000",
                    textDecoration: "none",
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                  }}
                >
                  Save & Continue {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddAllergens;
